import ko from "knockout";

// TODO Is this even used?

function viewmodel() {
    const notificationMessage = ko.observable("");
    const notificationVisible = ko.observable(false);
    const notificationType = ko.observable("");

    const notificationVisibleConverter = ko.pureComputed(function () {
        if (notificationVisible()) {
            return "inherit";
        } else {
            return "none";
        }
    }, this);

    function showNotification(message: string, messageType: string) {
        notificationMessage(message);

        if (messageType === "Critical") {
            notificationType("notificationAreaCritical");
            notificationVisible(true);
        } else if (messageType === "NonCritical") {
            notificationType("notificationAreaNonCritical");
            notificationVisible(true);
        } else if (messageType === "Notification") {
            notificationType("notificationAreaNotification");
            notificationVisible(true);
        } else notificationVisible(false);
    }

    function clearAll() {
        notificationVisible(false);
    }

    return {
        notificationMessage: notificationMessage,
        notificationVisible: notificationVisible,
        notificationType: notificationType,
        notificationVisibleConverter: notificationVisibleConverter,
        clearAll: clearAll,
        showNotification: showNotification
    };
}
export default viewmodel;
